import { CHECKOUT_ADDRESS_TARGET_PAGE_CODE } from './consts'

export type RegistrationOrigin = 'checkout' | 'home-one' | 'organic'

export const resolveRegistrationOrigin = ({
  hasTargetPageRedirectParam,
  targetPageCode,
}: {
  hasTargetPageRedirectParam: boolean
  targetPageCode: string | null
}): RegistrationOrigin => {
  if (targetPageCode === CHECKOUT_ADDRESS_TARGET_PAGE_CODE) {
    return 'checkout'
  }

  if (hasTargetPageRedirectParam) {
    return 'home-one'
  }

  return 'organic'
}
